module.exports = __webpack_public_path__ + "static/media/03.8aad0d8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/community/03.jpg
// module id = 55
// module chunks = 0